import { ImageHelper } from '@/lib/helpers/image.helper'
import { ERankingSlug, RankingConfig } from '@/types/auth'

const userImages = [
  ImageHelper.getImageUrlCdn('/October2023/mceclip3_72.png'),
  ImageHelper.getImageUrlCdn('/October2023/mceclip0_14.png'),
  ImageHelper.getImageUrlCdn('/October2023/mceclip1_67.png'),
  ImageHelper.getImageUrlCdn('/October2023/mceclip2_46.png'),
]

export const getUserRankingConfig = (): RankingConfig[] => {
  return [
    {
      slug: ERankingSlug.NEW_USER,
      value: 0,
      max_value: 500000,
      image: ImageHelper.getImageUrlCdn('/October2023/mceclip0_92.png'),
      mb_image: ImageHelper.getImageUrlCdn('/September2023/mceclip0_80.png'),
      next_ranking_image: ImageHelper.getImageUrlCdn(
        '/September2023/mceclip0_56.png'
      ),
      rank_image: ImageHelper.getImageUrlCdn('/October2023/mceclip0_92.png'),
      user_image: userImages[0],
      coefficient: 0,
      coefficient_line: 30,
      coupon_description: '<b>Ưu đãi 15% (tối đa 50k)</b> cho đơn hàng bất kỳ',
    },
    {
      slug: ERankingSlug.SILVER,
      value: 500000,
      max_value: 2000000,
      image: ImageHelper.getImageUrlCdn('/September2023/mceclip0_56.png'),
      mb_image: ImageHelper.getImageUrlCdn('/September2023/mceclip2_55.png'),
      next_ranking_image: ImageHelper.getImageUrlCdn(
        '/September2023/mceclip3_45.png'
      ),
      rank_image: ImageHelper.getImageUrlCdn('/September2023/mceclip0_56.png'),
      user_image: userImages[1],
      coefficient: 30,
      coefficient_line: 40,
      coupon_description: '<b>Ưu đãi 20% (tối đa 50k)</b> cho đơn hàng bất kỳ',
    },
    {
      slug: ERankingSlug.GOLD,
      value: 2000000,
      max_value: 5000000,
      image: ImageHelper.getImageUrlCdn('/September2023/mceclip3_45.png'),
      mb_image: ImageHelper.getImageUrlCdn('/September2023/mceclip3_94.png'),
      next_ranking_image: ImageHelper.getImageUrlCdn(
        '/September2023/mceclip1_32.png'
      ),
      rank_image: ImageHelper.getImageUrlCdn('/September2023/mceclip3_45.png'),
      user_image: userImages[2],
      coefficient: 70,
      coefficient_line: 30,
      coupon_description: '<b>Ưu đãi 20% (tối đa 100k)</b>cho đơn hàng bất kỳ',
    },
    {
      slug: ERankingSlug.CHAMPION,
      value: 5000000,
      max_value: Number.MAX_SAFE_INTEGER,
      image: ImageHelper.getImageUrlCdn('/September2023/mceclip1_32.png'),
      mb_image: ImageHelper.getImageUrlCdn('/September2023/mceclip1_100.png'),
      rank_image: ImageHelper.getImageUrlCdn('/September2023/mceclip1_32.png'),
      user_image: userImages[3],
      coefficient: 100,
      coefficient_line: 1,
      coupon_description: '<b>Ưu đãi 25% (tối đa 100K)</b> cho đơn hàng bất kỳ',
    },
  ]
}
